// project imports
// import { drawerWidth } from 'config';

// action - state management
import * as actionTypes from './actions';

// const date = new Date();

export const initialState = {
  isOpen: [], // for active default menu
  defaultId: 'default',
  fontFamily: 'Roboto',
  borderRadius: 8,
  opened: true,
  currentDate: new Date().toISOString(),
  selectedTime: { start_time: '', end_time: '' },
  selectedZone: 'all',
  isExpanded: false, // default sidebar state is closed
  videoSource: ''
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_CAMERA_SOURCE:
      return {
        ...state,
        videoSource: action.videoSource
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };
    case actionTypes.CURRENT_DATE:
      return {
        ...state,
        currentDate: action.currentDate
      };
    case actionTypes.SELECTED_TIME:
      return {
        ...state,
        selectedTime: action.selectedTime
      };
    case actionTypes.SET_SELECTED_ZONES:
      return {
        ...state,
        selectedZone: action.selectedZone
      };
    case actionTypes.SIDEBAR_STATE:
      return {
        ...state,
        isExpanded: action.isExpanded
      };
    default:
      return state;
  }
};

export default customizationReducer;
